export default __webpack_public_path__ + "static/media/IMG_1967.18ec98f0.JPG";